<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <h3>REPORTE PERSONALIZADO RECEPCIÓN DE TICKETS</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-primary btn-icon" @click="cargar_datos">
              <i class="fas fa-filter"></i> Filtrar
            </button>
            <button class="btn btn-success btn-icon" @click="exportar_excel">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <!-- <div class="row mt-2">
                    <div class="col">
                        <table class="table table-bordered">
                            <tr class="background-light">
                                <th>RANGO DE FECHAS</th>
                                <th>TICKET</th>
                                <th>GUÍA</th>
                                <th>PROVEEDOR</th>
                                <th>MATERIA PRIMA</th>
                                <th>ESPECIE</th>
                                <th>PRODUCTO</th>
                                <th>DESTINO</th>

                            </tr>
                            <tr>
                                <td>
                                    <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                                </td>
                                <td>
                                    <input type="number" name="" id="" v-model="codigo_ticket">
                                </td>
                                <td>
                                    <input type="number" name="" id="" v-model="numero_guia">
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="empresas_id" :closeOnSelect="false" :options="proveedores" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre" multiple @input="obtener_parametros_mp()">
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="especies_id" :options="especies" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="productos_ids" :options="productos" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div> -->

        <div class="row">
          <div class="col">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <h5 class="mb-0">CONFIGURACIÓN</h5>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row mb-2">
                      <div class="col">
                        <input type="text" name="" id="" placeholder="Nombre Configuracion"
                          v-model="nombre_configuracion" />
                        <button class="btn btn-sm btn-success ml-2" @click="guardar_config">
                          CREAR CONFIGURACIÓN
                        </button>
                      </div>
                      <div class="col text-right">
                        <button class="btn btn-sm btn-primary ml-2" @click="limpiar_filtros()">
                          <i class="fas fa-recycle"></i>
                          limpiar
                        </button>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col">
                        <div class="table-responsive" style="height: 130px; border: 1px solid #3c3c3c">
                          <table class="table table-bordered">
                            <tr class="fixed-default">
                              <th class="background-light" style="padding: 0.2em">
                                MIS CONFIGURACIONES
                              </th>
                              <th class="background-light text-center" style="padding: 0.2em">
                                APLICAR
                              </th>
                              <th class="background-light text-center" style="padding: 0.2em">
                                ACTUALIZAR
                              </th>
                              <th class="background-light text-center" style="padding: 0.2em">
                                ELIMINAR
                              </th>
                            </tr>
                            <tr :class="{ 'background-salmon-1': conf.seleccionado }" v-for="conf in configuraciones"
                              :key="conf.id">
                              <td style="padding: 0.2em" :class="{ 'background-salmon-1': conf.seleccionado }">
                                <span style="font-weight: bold">{{
                                  conf.nombre
                                }}</span>
                              </td>
                              <td class="text-center" style="padding: 0.2em">
                                <button class="btn btn-sm btn-primary" @click="aplicar_config(conf.json, conf.id)">
                                  <i class="fas fa-cog"></i>
                                </button>
                              </td>
                              <td class="text-center" style="padding: 0.2em">
                                <button class="btn btn-sm btn-warning" @click="actualizar_config(conf.id)"
                                  :disabled="!conf.seleccionado">
                                  <i class="fas fa-pen"></i>
                                </button>
                              </td>
                              <td class="text-center" style="padding: 0.2em">
                                <button class="btn btn-sm btn-danger" @click="eliminar_config(conf.id)">
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="row mb-2">
                                            <div class="col">
                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="agrupar_empresa"> EMPRESA PADRE (Principal)</label>
                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="agrupar_sucursal"> SUCURSAL PADRE (Principal)</label>
                                            </div>
                                        </div> -->

                    <div class="row">
                      <div class="col">
                        <div class="table-responsive" style="height: 450px; border: 1px solid #3c3c3c">
                          <table class="table">
                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                RANGO DE FECHAS
                              </th>
                              <td style="padding: 0.5em">
                                <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false"
                                  :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                TICKET
                              </th>
                              <td style="padding: 0.5em">
                                <input type="text" name="" id="" v-model="codigo_ticket" />
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                GUÍA
                              </th>
                              <td style="padding: 0.5em">
                                <input type="number" name="" id="" v-model="numero_guia" />
                              </td>
                            </tr>
                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                PATENTE
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="transportes_id"
                                  :closeOnSelect="false" :options="transportes" label="patente" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>
                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                PROVEEDOR
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="empresas_id"
                                  :closeOnSelect="false" :options="proveedores" @input="cargar_sucursales()"
                                  label="nombre" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                SUCURSAL
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="dependencias_id"
                                  :closeOnSelect="false" :options="dependencias" label="nombre" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                MATERIA PRIMA
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="mps_id" :closeOnSelect="false"
                                  :options="materias_primas" label="nombre" multiple @input="obtener_parametros_mp()">
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                ESPECIE
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="especies_id"
                                  :closeOnSelect="false" :options="especies" label="nombre" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                PRODUCTO
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="productos_ids"
                                  :options="productos" :closeOnSelect="false" label="nombre" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                DESTINO
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="(option) => option.id" v-model="destinos_id"
                                  :options="destinos" label="nombre" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                EMPRESA PADRE
                              </th>
                              <td style="padding: 0.5em">
                                <input type="checkbox" id="" value="" v-model="agrupar_empresa" />
                              </td>
                            </tr>

                            <tr>
                              <th class="background-light" style="padding: 0.5em">
                                SUCURSAL PADRE
                              </th>
                              <td style="padding: 0.5em">
                                <input type="checkbox" id="" value="" v-model="agrupar_sucursal" />
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>

                      <div class="col">
                        <!-- <div class="table-responsive">
                                                    <table class="table">
                                                        <tr class="thead-skyblue2">
                                                            <th :colspan="columnas.length">
                                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="todos" @change="setearTodos"> Todos</label>
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <td v-for="col in columnas" :key="col.label">
                                                                <label class="margen-1" for=""><input type="checkbox" id="" value="" v-model="col.show"> {{col.label}}</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div> -->

                        <div class="table-responsive" style="height: 450px; border: 1px solid #3c3c3c">
                          <table class="table">
                            <tr class="thead-skyblue2 fixed-default">
                              <th :colspan="columnas.length">
                                <label class="margen-1" for=""><input type="checkbox" id="" value="" v-model="todos"
                                    @change="setearTodos" />
                                  Todos</label>
                              </th>
                            </tr>

                            <tr v-for="col in columnas" :key="col.label">
                              <td style="padding: 0.5em">
                                <label class="margen-1" for=""><input type="checkbox" id="" value="" v-model="col.show" />
                                  {{ col.label }}</label>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{parametros_ids}}</pre> -->

        <!-- <div class="row">
                    <div class="col">
                        <label class="" for="" ><input type="checkbox" id="" value="" v-model="todos" @change="setearTodos"> Todos</label>

                        <label class="" for="" v-for="col in columnas" :key="col.label"><input type="checkbox" id="" value="" v-model="col.show"> {{col.label}}</label>

                        
                    </div>
                </div> -->

        <!-- <div class="row" v-for="mp in mps_parametros" :key="mp.id">
                    <div class="col">


                    <div class="accordion" id="accordionExample">
                        <div class="card">
                                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse" :data-target="`#collapse${mp.id}`" aria-expanded="false" aria-controls="collapseOne">
                                    <h5 class="mb-0">{{mp.nombre}}</h5>
                                </div>
                                <div :id="`collapse${mp.id}`" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div class="card-body">
                                    
                                         <div class="row">
                                            <div class="col">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tr class="" v-for="analisis in mp.analisis" :key="analisis.id">
                                                            <th :colspan="mp.length" class="thead-skyblue2">
                                                                {{analisis.nombre}}
                                                            </th>
                                                            <td v-for="p in analisis.parametros" :key="p.id">
                                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="p.check"> {{p.nombre}}</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                
                                                


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                        </div>
                    </div>


                    </div>
                </div> -->

        <!-- <div class="row" v-if="mps_parametros.length > 0">
                    <div class="col">


                    <div class="accordion" id="accordionExample">
                        <div class="card">
                                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse" :data-target="`#collapseParametros`" aria-expanded="false" aria-controls="collapseOne">
                                    <h5 class="mb-0">Parámetros</h5>
                                </div>
                                <div :id="`collapseParametros`" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div class="card-body">
                                    
                                         <div class="row">
                                            <div class="col">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tr class="" v-for="analisis in mps_parametros" :key="analisis.id">
                                                            <th class="thead-skyblue2">
                                                                {{analisis.nombre}}
                                                            </th>
                                                            <td v-for="p in analisis.parametros" :key="p.id">
                                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="p.check"> {{`${p.nombre} (${p.unidad_medida})`}}</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                
                                                


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                        </div>
                    </div>


                    </div>
                </div> -->

        <!-- <pre>{{mps_parametros_seleccionados}}</pre> -->

        <div class="row" v-if="analisis_parametros.length > 0">
          <div class="col">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse"
                  :data-target="`#collapseParametros`" aria-expanded="false" aria-controls="collapseOne">
                  <h5 class="mb-0">PARÁMETROS</h5>
                </div>
                <div :id="`collapseParametros`" class="collapse show" aria-labelledby="headingOne"
                  data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <label>
                          Seleccionar todo
                          <input type="checkbox" name="" id="" v-model="seleccionar_todo_analisis" @change="actualizar_todo_checks(seleccionar_todo_analisis)">
                        </label>
                        <div class="table-responsive">
                          <table class="table table-bordered">
                            <tr class="" v-for="(analisis, idx) in analisis_parametros" :key="analisis.id">
                              <th class="thead-skyblue2">
                                <label class="margen-1" for=""><input type="checkbox" id="" value=""
                                    v-model="analisis.check" @change="
                                      actualizar_checks(analisis.check, idx)
                                      " />
                                  {{ analisis.nombre }}</label>
                              </th>
                              <td v-for="p in analisis.parametros" :key="p.id">
                                <label class="margen-1" for=""><input type="checkbox" id="" value="" v-model="p.check" />
                                  {{
                                    `${p.nombre} ${p.unidad_medida
                                        ? `(${p.unidad_medida_texto})`
                                        : ""
                                      }`
                                  }}</label>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <pre>{{analisis_parametros_seleccionados}}</pre> -->

        <!-- <pre>{{analisis_parametros}}</pre> -->
        <div class="row">
          <div class="col">
            <button class="btn btn-primary" @click="izquierda()">
              <i class="fas fa-arrow-left"></i>
            </button>
            <button class="btn btn-primary" @click="derecha()">
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" id="tablita" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">
                  <tr>
                    <th style="background-color: #fff" class="fixed" v-for="c in columnas" :key="c.label" v-show="c.show">
                    </th>
                    <th :colspan="p.parametros.length" class="fixed outlineado background-salmon-3 text-center"
                      v-for="p in parametros" :key="p.id">
                      <span class="titulo_tabla_1">{{ p.nombre }}</span>
                    </th>
                  </tr>
                  <tr>
                    <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="c in columnas" :key="c.label"
                      v-show="c.show">
                      <span class="titulo_tabla_1">{{ c.label }}</span>
                    </th>
                    <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="p in parametros_seleccionados"
                      :key="p.id">
                      <span class="titulo_tabla_1">{{ p.nombre }}
                        {{
                          p.unidad_medida_texto
                          ? `(${p.unidad_medida_texto})`
                          : ""
                        }}</span>
                    </th>
                  </tr>
                  <!-- <tr>
                                            <th class="fixed-2"></th>
                                            <th class="fixed-2 text-center" v-for="m in mps_seleccionadas" :key="m.id">
                                                <table>
                                                    <tr>
                                                        <td style="width:100%">C/R</td>
                                                        <td style="width:100%">S/R</td>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr> -->
                </thead>
                <tbody>
                  <tr v-for="d in datos" :key="d.id" v-bind:class="{
                    'background-red-1': d.marcar_rojo == 1,
                    'background-light': d.seleccionado == 1,
                  }">
                    <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show" @click="
                      d.seleccionado == 1
                        ? (d.seleccionado = 0)
                        : (d.seleccionado = 1)
                      ">
                      <span class="fila_tabla_1" v-if="['number'].includes(c.tipo)">
                        {{
                          devuelve_valor(d, c.path, c.tipo) | formatear_miles
                        }}
                      </span>

                      <span class="fila_tabla_1" v-if="['string', 'datetime', 'date', 'time'].includes(
                            c.tipo
                          ) && !['cam', 'declaracion_jurada', 'numero_guia_reemplazadas'].includes(c.path)
                          ">
                        {{ devuelve_valor(d, c.path, c.tipo) }}
                      </span>

                      <span v-if="c.path == 'declaracion_jurada'">
                        <button v-show="c.path == 'declaracion_jurada' &&
                          d.declaracion_jurada != null
                          " class="btn btn-primary btn-sm" type="button" @click="abrirDeclaracion(d)">
                          <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                        </button>
                      </span>

                      <span v-if="c.path == 'cam'">
                        <button v-show="c.path == 'cam' && d.cam != null" class="btn btn-warning btn-sm" type="button"
                          @click="abrirCam(d)">
                          <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                        </button>
                      </span>

                      <span v-if="c.path != 'declaracion_jurada' && c.path != 'cam'">
                        <button v-show="c.path == 'numero_guia'" class="btn btn-danger btn-sm" type="button"
                          @click="abrirPdf(d.link_guia_origen)">
                          <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                        </button>

                        <template v-if="c.path == 'numero_guia_reemplazadas'">
                          <template v-for="(reemplazada, i) in d.guia_reemplazadas">
                            <span v-if="i !== 0"> - </span>
                            <span>{{ reemplazada.numero_guia }}&nbsp;</span>
                            <button class="btn btn-danger btn-sm" type="button" title="" @click="abrirPdf(reemplazada.url)">
                              <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                            </button>
                          </template>
                        </template>

                        <button v-show="c.path == 'numero_guia_traslado' && d.link_guia_traslado != null" class="btn btn-danger btn-sm" type="button"
                          @click="abrirPdf(d.link_guia_traslado)">
                          <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                        </button>

                      </span>
                    </td>

                    <td class="text-center fila_tabla_1" v-for="p in parametros_seleccionados" :key="p.id" @click="
                      d.seleccionado == 1
                        ? (d.seleccionado = 0)
                        : (d.seleccionado = 1)
                      ">
                      {{ devuelve_valor_parametro(d, p) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <table class="table table-bordered">
              <thead class="thead-blue">
                <tr>
                  <th class="text-center">TOTAL PESO INFORMADO (KG)</th>
                  <th class="text-center">TOTAL PESO RECIBIDO (KG)</th>
                  <th class="text-center">TOTAL PESO DISTRIBUCIÓN (KG)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="total_resultado">
                  <td class="text-center">
                    {{ total_resultado.total_peso_informado | formatear_miles }}
                  </td>
                  <td class="text-center">
                    {{ total_resultado.total_peso_recibido | formatear_miles }}
                  </td>
                  <td class="text-center">
                    {{ total_resultado.total_distribucion | formatear_miles }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
        <!-- <pre>{{fechas}}</pre> -->
        <!-- <pre>{{total_resultado}}</pre> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    todos: true,
    columnas: [
      {
        show: true,
        label: "Fecha Ticket",
        tipo: "date",
        path: "fecha_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Hora Ticket",
        tipo: "time",
        path: "hora_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Ticket",
        tipo: "string",
        path: "codigo_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Sucursal",
        tipo: "string",
        path: "sucursal",
        ancho_excel: 35,
      },
      /*{
        show: true,
        label: "Km Teórico",
        tipo: "string",
        path: "km_teorico",
        ancho_excel: 35,
      },*/
      {
        show: true,
        label: "SIEP",
        tipo: "string",
        path: "codigo_siep",
        ancho_excel: 35,
      },
      {
        show: true,
        label: "Materia Prima",
        tipo: "string",
        path: "materia_prima",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Destino Distribución",
        tipo: "string",
        path: "destino_distribucion",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "Patente",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Guía Traslado",
        tipo: "string",
        path: "numero_guia_traslado",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Guía",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Guía Reemplazadas",
        tipo: "string",
        path: "numero_guia_reemplazadas",
        ancho_excel: 26,
      },
      {
        show: true,
        label: "Empresa",
        tipo: "string",
        path: "empresa",
        ancho_excel: 35,
      },
      {
        show: true,
        label: "Peso Informado Guía (kg)",
        tipo: "number",
        path: "peso_informado_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Peso Informado Guía Prorrateado (kg)",
        tipo: "number",
        path: "peso_informado_guia_distribucion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Cantidad Bins",
        tipo: "number",
        path: "cantidad_bins",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Peso Recibido Guía (Romana) (Kg)",
        tipo: "number",
        path: "peso_real_guia",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Peso Distribucion (Kg)",
        tipo: "number",
        path: "peso_real_distribucion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Fecha Guía (Salida Origen)",
        tipo: "datetime",
        path: "fecha_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Declaracion Jurada",
        tipo: "string",
        path: "declaracion_jurada",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CAM",
        tipo: "string",
        path: "cam",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Especie",
        tipo: "string",
        path: "especie",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Producto",
        tipo: "string",
        path: "producto",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "Restriccion",
        tipo: "string",
        path: "restricciones",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tiempo Camion en Planta",
        tipo: "string",
        path: "tiempo_camion_planta",
        ancho_excel: 22,
      },

      //{show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
      /* {show:true,label:'Fecha Ticket',tipo:'date',path:'fecha_ticket'},
            {show:true,label:'Hora Ticket',tipo:'time',path:'hora_ticket'},
            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket'},
            {show:true,label:'Fecha Guía (Salida Origen)',tipo:'datetime',path:'fecha_guia'},
            {show:true,label:'N° Guía',tipo:'string',path:'numero_guia'},
            {show:true,label:'Declaracion Jurada',tipo:'string',path:'declaracion_jurada'},
            {show:true,label:'CAM',tipo:'string',path:'cam'},
            {show:true,label:'Empresa',tipo:'string',path:'empresa'},
            {show:true,label:'Sucursal',tipo:'string',path:'sucursal'},
            {show:true,label:'Materia Prima',tipo:'string',path:'materia_prima'},
            {show:true,label:'Especie',tipo:'string',path:'especie'},
            {show:true,label:'Producto',tipo:'string',path:'producto'},
            {show:true,label:'Restriccion',tipo:'string',path:'restricciones'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Tiempo Camion en Planta',tipo:'string',path:'tiempo_camion_planta'},
            {show:true,label:'Cantidad Bins',tipo:'number',path:'cantidad_bins'},
            {show:true,label:'Peso Informado Guía (kg)',tipo:'number',path:'peso_informado_guia'},
            {show:true,label:'Peso Recibido Guía (Romana) (Kg)',tipo:'number',path:'peso_real_guia'},
            {show:true,label:'Destino Distribución',tipo:'string',path:'destino_distribucion'},
            {show:true,label:'Peso Distribucion (Kg)',tipo:'number',path:'peso_real_distribucion'}, */
    ],

    proveedores: [],
    dependencias: [],
    transportes: [],
    datos: [],
    mps_id: [],
    //mps_id:null,
    transportes_id: [],
    destinos_id: [],
    empresas_id: [],
    dependencias_id: [],
    especies_id: [],
    materias_primas: [],
    especies: [],
    mps_seleccionadas: [],
    destinos: [],
    total_resultado: null,
    url_excel: null,
    agrupar_empresa: false,
    agrupar_sucursal: false,
    productos: [],
    productos_ids: [],
    mps_parametros: [],
    codigo_ticket: "",
    numero_guia: "",
    analisis_parametros: [],
    parametros: [],
    nombre_configuracion: "",
    configuraciones: [],
    id_config: null,
    seleccionar_todo_analisis: false,
  }),
  mounted() {
    this.cargar_configuraciones();
  },
  methods: {
    aplicar_config(json, id) {
      this.limpiar_filtros();

      this.configuraciones.forEach((c, idx) => {
        if (c.id == id) {
          this.$set(this.configuraciones[idx], 'seleccionado', true);
        } else {
          this.$set(this.configuraciones[idx], 'seleccionado', false);
        }
      });

      let objeto = JSON.parse(json);
      //console.log(objeto);
      Object.keys(objeto).forEach((key) => {
        if (key == "columnas") {
          objeto[key].forEach((c) => {
            let idx = this.columnas.findIndex((col) => col.path == c);
            this.$set(this.columnas[idx], "show", true);
          });
        } else {
          this[key] = objeto[key];
        }
      });
    },

    limpiar_filtros() {
      this.fechas = [];
      this.mps_id = [];
      this.destinos_id = [];
      this.empresas_id = [];
      this.especies_id = [];
      this.productos_ids = [];
      this.fechas = [];
      this.codigo_ticket = "";
      this.numero_guia = "";
      this.agrupar_empresa = false;
      this.agrupar_sucursal = false;
      this.todos = false;
      this.columnas.forEach((c) => (c.show = false));
      this.configuraciones.forEach((c, idx) => {
        this.$set(this.configuraciones[idx], 'seleccionado', false);
      });
    },

    async cargar_configuraciones() {
      await this.axios
        .post(
          `${this.api}/configuraciones/path`,
          { path: this.$router.currentRoute.path },
          this.cabeceras_json
        )
        .then((res) => {
          this.configuraciones = res.data.data;
          this.configuraciones.forEach((c, idx) => {
            this.$set(this.configuraciones[idx], 'seleccionado', false);
          });
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_analisis_y_parametros();
    },

    derecha() {
      //console.log("sii");
      document.getElementById("tablita").scrollLeft += 500;
    },

    izquierda() {
      //console.log("sii");
      document.getElementById("tablita").scrollLeft -= 500;
    },

    async cargar_analisis_y_parametros() {
      await this.axios
        .get(`${this.api}/reportes/analisis_y_parametros`, this.cabeceras_json)
        .then((res) => {
          //console.log('se mete aqui',res.data.status);
          if (res) {
            this.analisis_parametros = res.data.data;
          }
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_materias_primas();
    },
    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.materias_primas = res.data.data.data;
          }
        })
        .catch((e) => {
          //console.log(e);            $r->cam = @DB::table('guias_info_adicional')->where('guias_id',$r->guias_id)->where('dato_adicional_id',2)->first()->valor_campo;
        });
      this.cargar_destinos();
    },

    async cargar_destinos() {
      await this.axios
        .get(`${this.api}/destinos`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.destinos = res.data.data;
          }
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_proveedores();
    },

    async cargar_proveedores() {
      /* await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          }); */
      await this.axios
        .get(`${this.api}/proveedores`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.proveedores = res.data.data;
          }
          //console.log("res", res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_especies();
    },

    async cargar_sucursales() {
      await this.axios
        .post(`${this.api}/get_sucursales`, { empresas_id: this.empresas_id }, this.cabeceras_json)
        .then((res) => {
          console.log("res", res.data.data);
          this.dependencias = res.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async cargar_transportes() {
      await this.axios
        .get(`${this.api}/transportes?limit=99999`, this.cabeceras_json)
        .then((res) => {
          console.log("res", res.data.data);
          this.transportes = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async cargar_especies() {
      await this.axios
        .get(`${this.api}/especies?limit=9999999999`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.especies = res.data.data.data;
          }
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_productos();
    },

    async cargar_productos() {
      await this.axios
        .get(
          `${this.api}/productos_recibidos?limit=9999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          if (res) {
            this.productos = res.data.data.data;
          }
        })
        .catch((e) => {
          //console.log(e);
        });

      this.cargar_transportes()
    },

    async filtrarProveedores(search) {
      await this.axios
        .get(
          `${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.proveedores = res.data.data.data;
          ////console.log('res',res.data.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      ////console.log('search',search)
      ////console.log('col',col)
    },

    async cargar_datos() {
      this.datos = [];
      this.parametros = [];
      this.total_resultado = null;
      this.url_excel = null;
      //if(this.fechas[0] != null && this.fechas[0] != undefined){
      let loader = this.$loading.show({
        // Optional parameters
        //container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: '#262b63',
        backgroundColor: '#ededed',
        //onCancel: this.onCancel,
        loader: 'spinner'
      });

      let body = {
        //desde:this.fechas[0],
        //hasta:this.fechas[1],
        mps_id: this.mps_id,
        //empresas_id:this.empresas_id,
        destinos_id: this.destinos_id,
        especies_id: this.especies_id,
        productos_ids: this.productos_ids,
        agrupar_empresa: this.agrupar_empresa,
        agrupar_sucursal: this.agrupar_sucursal,
        columnas: this.columnas
          .filter(
            (c) =>
              c.show == true &&
              c.path != "declaracion_jurada" &&
              c.path != "cam"
          )
          .map((c) => {
            return {
              cabecera: c.label,
              path: c.path,
              tipo: c.tipo,
              ancho_excel: c.ancho_excel,
            };
          }),
        /* parametros:this.mps_parametros_seleccionados,
                    parametros_ids:this.parametros_ids */
      };
      if (this.analisis_parametros_seleccionados.length > 0) {
        body.analisis_parametros = this.analisis_parametros_seleccionados;
      }
      if (this.empresas_id.length > 0) {
        body.empresas_id = this.empresas_id;
      }

      if (this.dependencias_id.length > 0) {
        body.dependencias_id = this.dependencias_id;
      }
      if (this.transportes_id.length > 0) {
        body.transportes_id = this.transportes_id;
      }
      if (this.codigo_ticket) {
        body.codigo_ticket = this.codigo_ticket;
      }
      if (this.numero_guia) {
        body.numero_guia = this.numero_guia;
      }

      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        body.desde = this.fechas[0];
        body.hasta = this.fechas[1];
      }
      await this.axios
        .post(`${this.api}/reportes/personalizado`, body, this.cabeceras_json)
        .then((res) => {
          //console.log(res.data.data);
          this.datos = res.data.data.data;
          this.parametros = res.data.data.parametros;
          this.total_resultado = res.data.data.total;
          this.url_excel = res.data.data.url;
          loader.hide();
          //console.log("url_excel", this.url_excel);
        })
        .catch((e) => {
          //console.log(e);
          loader.hide();
        });
      //}
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
      /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
    },

    async obtener_parametros_mp() {
      //console.log("aqui", this.mps_id);
      let body = {
        mp_tipos_id: this.mps_id,
      };
      await this.axios
        .post(
          `${this.api}/reportes/personalizado/obtener_parametros_mp`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.mps_parametros = res.data.data;
          //console.log(this.mps_parametros);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      if (tipo_dato == "datetime") {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == "date") {
        valor = this.$options.filters.fecha(valor);
      }
      if (tipo_dato == "time") {
        valor = this.$options.filters.hora(valor);
      }
      return valor;
    },

    devuelve_valor_parametro(item, parametro) {
      let valor = "";
      parametro.lab_item_parametros_ids.forEach((id) => {
        let find = item.lab_analisis_detalles.find(
          (i) => i.lab_item_parametros_id == id
        );
        if (find) {
          valor = find.valor;
        }
      });
      return valor;
    },

    setearTodos() {
      this.columnas.forEach((c) => {
        c.show = this.todos;
      });
    },

    abrirPdf(link) {
      //let url = `${this.api_public}/${carpeta}/${archivo}`
      window.open(link, "_blank");
    },

    abrirDeclaracion(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`,
        "_blank"
      );
    },

    abrirCam(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.cam}`,
        "_blank"
      );
    },

    actualizar_checks(check, idx) {
      this.analisis_parametros[idx].parametros.forEach(
        (p) => (p.check = check)
      );
    },

    actualizar_todo_checks(check) {
      this.analisis_parametros.forEach(analisis => {
        analisis.check = check;
        analisis.parametros.forEach(parametro => {
          parametro.check = check;
        });
      });
    },

    async guardar_config() {
      let body = {
        nombre: this.nombre_configuracion,
        users_id: this.usuario.id,
        path: this.$router.currentRoute.path,
        json: JSON.stringify(this.actual_config),
      };

      if (this.nombre_configuracion != "") {
        await this.axios
          .post(`${this.api}/configuraciones`, body, this.cabeceras_json)
          .then((res) => {
            this.configuraciones.push(res.data.data);
            this.nombre_configuracion = '';
          })
          .catch((e) => {
            //console.log(e);
          });
      }
    },

    async actualizar_config(id) {
      let body = {
        json: JSON.stringify(this.actual_config),
      };


      await this.axios
        .put(`${this.api}/configuraciones/${id}`, body, this.cabeceras_json)
        .then((res) => {
          let idx = this.configuraciones.findIndex(c => c.id == id);
          this.$set(this.configuraciones[idx], 'json', res.data.data.json);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async eliminar_config(id) {
      let index = this.configuraciones.findIndex(c => c.id == id)


      await this.axios
        .delete(`${this.api}/configuraciones/${id}`, this.cabeceras_json)
        .then((res) => {
          let idx = this.configuraciones.findIndex(c => c.id == id);
          this.configuraciones.splice(index,1);
          //this.$set(this.configuraciones[idx], 'json', res.data.data.json);
        })
        .catch((e) => {
          //console.log(e);
        });
    },
  },
  computed: {
    path() {
      return this.$router.currentRoute.path;
    },

    actual_config() {
      let json = {};
      if (this.fechas.length > 0) {
        json.fechas = this.fechas;
      }
      if (this.codigo_ticket) {
        json.codigo_ticket = this.codigo_ticket;
      }

      if (this.numero_guia) {
        json.numero_guia = this.numero_guia;
      }

      if (this.mps_id.length > 0) {
        json.mps_id = this.mps_id;
      }

      if (this.destinos_id.length > 0) {
        json.destinos_id = this.destinos_id;
      }

      if (this.empresas_id.length > 0) {
        json.empresas_id = this.empresas_id;
      }

      if (this.especies_id.length > 0) {
        json.especies_id = this.especies_id;
      }

      if (this.productos_ids.length > 0) {
        json.productos_ids = this.productos_ids;
      }

      if (this.agrupar_empresa) {
        json.agrupar_empresa = this.agrupar_empresa;
      }

      if (this.agrupar_sucursal) {
        json.agrupar_sucursal = this.agrupar_sucursal;
      }

      json.columnas = this.columnas
        .filter(
          (c) =>
            c.show == true && c.path != "declaracion_jurada" && c.path != "cam"
        )
        .map((c) => c.path);
      return json;
    },

    analisis_parametros_seleccionados() {
      let analisis = this.analisis_parametros
        .filter((a) => {
          return a.parametros.filter((p) => p.check == true).length > 0;
        })
        .map((a) => {
          return {
            id: a.id,
            nombre: a.nombre,
            parametros: a.parametros.filter((p) => p.check == true),
          };
        });

      return analisis;
    },

    mps_parametros_seleccionados() {
      let array = [];

      let analisis = [];

      /* this.mps_parametros.forEach(mp => {
                mp.analisis.forEach(a => {
                    let count = 0; 
                    let parametros = [];
                    a.parametros.forEach(p => {
                        if(p.check){
                            parametros.push(p);
                            count ++;
                        }
                    });
                    if(count>0){
                        analisis.push({
                            analisis_id:a.id,
                            mp_tipos_id:a.mp_tipos_id,
                            nombre:a.nombre,
                            parametros:parametros
                        });
                    }
                });
            });

            this.mps_parametros.forEach(mp => {
                let items_analisis = analisis.filter(a=>a.mp_tipos_id == mp.id);
                if(items_analisis.length > 0){
                    array.push({
                        id:mp.id,
                        nombre:mp.nombre,
                        analisis:items_analisis
                    });
                }
            }); */

      this.mps_parametros.forEach((a) => {
        let count = 0;
        let parametros = [];
        a.parametros.forEach((p) => {
          if (p.check) {
            parametros.push(p);
            count++;
          }
        });
        if (count > 0) {
          analisis.push({
            analisis_id: a.id,
            mp_tipos_id: a.mp_tipos_id,
            nombre: a.nombre,
            parametros: parametros,
          });
        }
      });

      /* this.mps_parametros.forEach(mp => {
                let items_analisis = analisis.filter(a=>a.mp_tipos_id == mp.id);
                if(items_analisis.length > 0){
                    array.push({
                        id:mp.id,
                        nombre:mp.nombre,
                        analisis:items_analisis
                    });
                }
            }); */

      return analisis;
    },

    parametros_ids() {
      let array = [];
      this.mps_parametros_seleccionados.forEach((analisis) => {
        analisis.parametros.forEach((p) => {
          array.push(p.lab_item_parametros_id);
        });
      });

      return array;
    },

    parametros_seleccionados() {
      let array = [];
      this.parametros.forEach((element) => {
        array = array.concat(element.parametros);
      });
      return array;
    },

    ...mapState([
      "api",
      "api_public",
      "cabeceras_json",
      "token",
      "menus",
      "usuario",
    ]),
  },
};
</script>
<style>
.tableFixHead {
  overflow: auto;
  height: 600px;
  border: 1px solid rgb(212, 212, 212);
}

/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 46px;
}

.fixed-2 {
  position: sticky;
  top: 46px;
  z-index: 10;
}

.fixed-default {
  position: sticky;
  top: 0;
  z-index: 10;
}

.outlineado {
  outline: 1px solid rgb(17, 15, 15);
}

/* Just common table stuff. Really. */
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 8px 16px;
}

/*th     { background:#427391; color:#fff }*/
.margen-1 {
  margin: 0em 0.5em;
}

.wrapper1,
.wrapper2 {
  width: 100%;
  border: none 0px RED;
  overflow-x: scroll;
  overflow-y: scroll;
}

.wrapper1 {
  height: 20px;
}

.wrapper2 {
  height: 600px;
}
</style>